
<template>
  <div  class="root-container">
    <el-table
      :data="cmiStep"

      border>
      <!--<el-table-column prop="number" label="编号" width="100"></el-table-column>-->
      <el-table-column prop="step"   :label="labelTag" >
        <template slot-scope="scope">
          <el-input v-model="scope.row.step"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value"  :label="labelVal" >
        <template slot-scope="scope">
          <el-input v-model="scope.row.value"></el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="100">
        <template slot-scope="scope">
          <el-button @click="handleDeleteOne(scope.$index)" style="color: red" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-button @click="onClickAdd" size="small">添加</el-button>
  </div>

</template>

<style>

  .root-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }


</style>

<script>

  import commonUtils from "../../../utils/commonUtils";

  export default {
    name: 'CmiStep',
    props: {
      steps :Array,
      stepType:Object,
    },
    data() {
      return {
        cmiStep:[],
        labelTag:"",
        labelVal:""
      }
    },
    mounted() {

    },
    created(){
      if (this.stepType == 0){
        this.labelTag = "业绩"
        this.labelVal = "提成比例"
      }else if (this.stepType ==2){
        this.labelTag = "上课类型"
        this.labelVal = "课时费"
      } else if (this.stepType ==1){
        this.labelTag = "目标"
        this.labelVal = "目标值"
      }
      if (commonUtils.isArrayNull(this.steps)){
        return;
      }
      for (let i = 0;i< this.steps.length;++i){
        let data = {
          step:this.steps[i].step,
          value:this.steps[i].value,
        }
        this.cmiStep.push(data);
      }
    },
    methods: {
      handleDeleteOne(index){
        this.cmiStep.splice(index,1);
      },
      onClickAdd(){
        let data = {
          step:0,
          value:0

        }
        this.cmiStep.push(data);
        console.log("onClickAdd",this.cmiStep)
      },

      getStepString(){
        return JSON.stringify(this.cmiStep) ;
      }
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/my-store/salary-commisson/CmiStep.vue